<template>
  <div>
   <!-- <small class="date-label">{{$t('selectUser')}}</small> -->
    <v-select
      :placeholder="$t('selectUser')"
      label="userName"
      :closeOnSelect="true"
      v-model="selectedUserId"
      :options="users"
      :reduce="users => users.id"
      @input="send"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
// import UserService from "../../http/services/users";
import http from "../../../src/http/http-helper";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      users: [],
      selectedUserId: "",
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      let path = "/users/getlist";
      http.get(path).then((response) => {
        var users = response;
        users.forEach((element) => {
          var data = { id: element.id, userName: element.userName };
          this.users.push(data);
        });
      });

      // UserService.getUsers()
      //   .then(response => {
      //     response.data.forEach(element => {
      //       var data = { id: element.id, userName: element.userName };
      //       this.users.push(data);
      //     });
      //   })
      //   .catch(err => {
      //     this.$vs.notify({
      //       title: "Hata",
      //       text: this.$t("logListColudntTake"),
      //       color: "danger"
      //     });
      //   });
    },
    send(data) {
      this.$emit("receiveData", data);
    },
  },
};
</script>